module.exports = __webpack_public_path__ + "static/media/icon-chevron-down2.bb771a28.svg";